import { getFontCss, styleConstants } from '@paywithextend/components'
import React from 'react'
import { useSelector } from 'react-redux'
import SvgBetaPurple from 'src/components/Svgs/SvgBetaPurple'
import TextWithTooltipOnClick, {
  TextWithTooltipOnClickSize,
} from 'src/components/TextWithTooltipOnClick/TextWithTooltipOnClick'
import Trns from 'src/localization/Trns'
import { selectFeedbackSurveyUrlFromState } from 'src/redux/selectors/session.selectors'
import { css } from 'styled-components'

interface BetaTagProps {
  isBetaTagHeader?: boolean
  tooltipBody?: React.ReactElement
  openLeft?: boolean
  className?: string
  hideTooltip?: boolean
}

const BetaTag: React.FC<BetaTagProps> = (props): React.ReactElement => {
  const feedbackSurveyUrl = useSelector(selectFeedbackSurveyUrlFromState)

  return (
    <TextWithTooltipOnClick
      className={props.className}
      disabled={props.hideTooltip}
      text={
        <span
          css={css`
            display: flex;
            align-items: center;
            background-color: rgb(103, 36, 249, 0.15);
            border-radius: 5px;
            padding-right: 6px;
          `}
        >
          <SvgBetaPurple
            css={css`
              transform: scale(0.6);
              padding: 0px;
              margin-right: -4px;
            `}
          />
          <span
            css={css`
              ${getFontCss(
                12,
                styleConstants.colors.purple_dark,
                styleConstants.fontFamilies.medium,
              )};
            `}
          >
            {'Beta'}
          </span>
        </span>
      }
      tooltipBody={
        props.tooltipBody !== undefined ? (
          props.tooltipBody
        ) : (
          <span>
            <Trns
              source={
                'This feature is still under heavy development as we fine-tune functionality and design. If you have feedback, ${feedbackLink}'
              }
              expressions={{
                feedbackLink: (
                  <a
                    href={feedbackSurveyUrl}
                    css={css`
                      text-decoration: underline;
                    `}
                    target={'_blank'}
                    rel="noopener noreferrer"
                  >
                    <Trns source={'let us know!'} />
                  </a>
                ),
              }}
            />
          </span>
        )
      }
      openLeft={props.openLeft}
      hover
      size={TextWithTooltipOnClickSize.Medium}
      tooltipSize={TextWithTooltipOnClickSize.Medium}
      isBetaTagHeader={props.isBetaTagHeader}
    />
  )
}

export default BetaTag
